import { AllieText } from '../../../Text';
import { AllieSelect } from '../../../Select';
import { StyledSortContainer } from './DataGridSort.styles';
import { useState } from 'react';

interface DataGridSortProps {
  columns: any[];
  onChange: (value: any) => void;
  labelSortBy: string;
  labelNoOrder: string;
  labelAsc?: string;
  labelDesc?: string;
}

const DEFAULT_DIRECTION = 'asc';

export const DataGridSort: React.FC<DataGridSortProps> = ({
  columns,
  onChange,
  labelSortBy,
  labelNoOrder,
  labelAsc,
  labelDesc,
}) => {
  const [firstLoad, setFirstLoad] = useState(true);
  const WITHOUT_SORT_OPTION = {
    text: labelNoOrder,
    value: '-',
  };

  const directionMap = {
    asc: labelAsc || 'Asc',
    desc: labelDesc || 'Desc',
  };

  const filterMapColumns = (filterColumns: any[]) =>
    filterColumns
      .filter((column) => column.columnDef.enableSorting)
      .reduce((options, column) => {
        if (
          column.columnDef.meta?.sortDirection &&
          column.columnDef.meta.sortDirection.length > 0
        ) {
          return [
            ...options,
            ...column.columnDef.meta.sortDirection.map((direction: string) => ({
              text: `${column.columnDef.header().props.title} ${
                directionMap[direction as keyof typeof directionMap]
              }`,
              value: `${column.id}-${direction}`,
            })),
          ];
        }
        return [
          ...options,
          {
            text: column.columnDef.header().props.title,
            value: column.id,
          },
        ];
      }, []);

  const getValue = (value: any) => {
    const [field, direction] = value.split('-');
    return {
      field,
      direction: direction || DEFAULT_DIRECTION,
    };
  };

  return (
    <StyledSortContainer>
      <div style={{ marginRight: 10 }}>
        <AllieText type="body1" color="neutral-90">{`${labelSortBy}:`}</AllieText>
      </div>
      <AllieSelect
        options={[WITHOUT_SORT_OPTION, ...filterMapColumns(columns)]}
        selectedText={firstLoad ? WITHOUT_SORT_OPTION.text : undefined}
        onChange={(e) => {
          setFirstLoad(false);
          if (WITHOUT_SORT_OPTION.value === e.detail.value) {
            onChange([]);
          } else {
            onChange([getValue(e.detail.value)]);
          }
        }}
        color={{
          backgroundColor: 'white',
          allieColor: 'neutral-60',
        }}
      />
    </StyledSortContainer>
  );
};
